import moment from "moment-timezone";
import { useEffect, useState } from "react";

const useRealTimerForUpcomingBooking = (contractDate, contractStartTime) => {
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const startTime = moment.tz(
      `${contractDate} ${contractStartTime}`,
      "YYYY-MM-DD HH:mm:ss",
      "Europe/London",
    );

    const updateStatusMessage = () => {
      const now = moment.tz("Europe/London");

      if (now.isBefore(startTime)) {
        const diff = startTime.diff(now);
        const duration = moment.duration(diff);

        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        let timeString = "";
        if (hours > 0) timeString += `${hours} hour${hours > 1 ? "s" : ""} `;
        if (minutes > 0 || hours > 0)
          timeString += `${minutes} minute${minutes > 1 ? "s" : ""} `;
        timeString += `${seconds} second${seconds > 1 ? "s" : ""}`;

        setStatusMessage(`Shift starts in ${timeString}`);
      } else {
        const diff = now.diff(startTime);
        const duration = moment.duration(diff);

        const hoursLate = Math.floor(duration.asHours());
        const minutesLate = duration.minutes();
        const secondsLate = duration.seconds();

        let lateMessage = "Candidate late by ";
        if (hoursLate > 0)
          lateMessage += `${hoursLate} hour${hoursLate !== 1 ? "" : ""} `;
        if (minutesLate > 0 || hoursLate > 0)
          lateMessage += `${minutesLate} minute${minutesLate !== 1 ? " " : ""} `;
        lateMessage += `${secondsLate} second${secondsLate !== 1 ? " " : ""}`;
        setStatusMessage(lateMessage);
      }
    };

    updateStatusMessage();
    const intervalId = setInterval(updateStatusMessage, 1000);

    return () => clearInterval(intervalId);
  }, [contractDate, contractStartTime]);

  return statusMessage;
};

export default useRealTimerForUpcomingBooking;
